"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.protoEnumTypes = exports.landingDisplayLabels = exports.dbLandingTypes = void 0;
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var landingDisplayLabels = exports.landingDisplayLabels = {
  local: 'User Profile Preference',
  observationDeck: 'Observation Deck',
  nmsDashboard: 'NMS Dashboard',
  networkExplorer: 'Network Explorer',
  library: 'Library',
  synthetics: 'Synthetics',
  explorer: 'Data Explorer',
  alerting: 'Alerting',
  insights: 'Insights',
  dashboard: 'Dashboard',
  'saved-view': 'Saved View',
  'quick-view': 'Quick View',
  'market-intel': 'Market Intelligence'
};
var protoEnumTypes = exports.protoEnumTypes = {
  LANDING_TYPE_LOCAL: 'local',
  LANDING_TYPE_OBSERVATION_DECK: 'observationDeck',
  LANDING_TYPE_NMS_DASHBOARD: 'nmsDashboard',
  LANDING_TYPE_NETWORK_EXPLORER: 'networkExplorer',
  LANDING_TYPE_LIBRARY: 'library',
  LANDING_TYPE_SYNTHETICS: 'synthetics',
  LANDING_TYPE_EXPLORER: 'explorer',
  LANDING_TYPE_ALERTING: 'alerting',
  LANDING_TYPE_INSIGHTS: 'insights',
  LANDING_TYPE_DASHBOARD: 'dashboard',
  LANDING_TYPE_SAVED_VIEW: 'saved-view',
  LANDING_TYPE_QUICK_VIEW: 'quick-view',
  LANDING_TYPE_MARKET_INTELLIGENCE: 'market-intel'
};
var dbLandingTypes = exports.dbLandingTypes = Object.fromEntries(Object.entries(protoEnumTypes).map(function (_ref) {
  var _ref2 = (0, _slicedToArray2["default"])(_ref, 2),
    enumName = _ref2[0],
    key = _ref2[1];
  return [key, enumName];
}));